/**
 * Navigation state for leaving the post-call screen.
 *
 * The live-room flow is MeetingsTabs -> MeetingJoin (transparentModal) ->
 * Etiquette -> Call -> (replace) PostCall, so a transparentModal sits in the
 * stack underneath the whole call. Popping back to MeetingsTabs with
 * `navigate()` crosses that modal boundary in a single action, and on iOS
 * react-native-screens fails to tear down the intermediate modal's native view
 * controller — leaving the post-call screen presented and swipe-dismissable
 * behind the main screen (#97).
 *
 * Resetting the stack instead rebuilds it from scratch, discarding the lingering
 * modal and every intermediate screen, so there is nothing left to swipe back
 * to. These builders return the state object passed to `navigation.reset()`.
 */

export function postCallExitState() {
  return {
    index: 0,
    routes: [
      { name: "MeetingsTabs" as const, params: { screen: "AllMeetings" } },
    ],
  };
}

export function postCallScheduleAnotherState() {
  return {
    index: 1,
    routes: [{ name: "MeetingsTabs" as const }, { name: "Schedule" as const }],
  };
}
